import { useNavigate } from "react-router-dom"
import { Button, type ButtonProps } from "@/components/ui/button"
import { useAppDispatch } from "@/store/hooks"
import { addProduct, type CartProduct } from "@/store/slices/cartSlice"

interface BuyNowButtonProps {
	cartItem: CartProduct
	text?: string
	variant?: ButtonProps["variant"]
	size?: ButtonProps["size"]
	className?: string
}

/** Añade el ítem al carrito y salta al paso 2 del checkout. */
export default function BuyNowButton({
	cartItem,
	text = "Comprar ahora",
	variant = "default",
	size = "default",
	className
}: BuyNowButtonProps): React.JSX.Element {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	return (
		<Button
			variant={variant}
			size={size}
			className={className}
			onClick={() => {
				dispatch(addProduct(cartItem))
				void navigate("/checkout/datos")
			}}
		>
			{text}
		</Button>
	)
}
